// Checks if clicked on a link, if so it stops the propagation.
export function checkClick($event) {
    let target = $event.target;
    while(target !== $event.currentTarget){
        if(target.tagName == 'A'){
            $event.stopPropagation();
        }
        target = target.parentNode;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/stopClickPropagation.ts